// TwilioCredentialsHelp.js
import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function TwilioCredentialsHelp() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Finding Your Twilio&nbsp;SID&nbsp;&amp;&nbsp;Auth&nbsp;Token
      </Typography>

      <Typography paragraph>
        Gather three essentials in the Twilio Console before connecting PostSheet.
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;Log in at&nbsp;
            <a href="https://console.twilio.com" target="_blank" rel="noopener noreferrer">
              console.twilio.com
            </a>.
          </Typography>
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;In&nbsp;<strong>Project&nbsp;Info</strong>, copy your&nbsp;<em>Account&nbsp;SID</em>;
            click&nbsp;<em>Reveal&nbsp;Auth&nbsp;Token</em> and copy it too.
          </Typography>
          <img src="../../static/docs/GetTwilioSettings.jpg" alt="Twilio Project Info" className="step-img" />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            3&nbsp;·&nbsp;Go to&nbsp;<strong>Phone&nbsp;Numbers → Manage</strong>, pick or buy a number.
            For WhatsApp, ensure it’s WhatsApp-enabled in&nbsp;<em>Messaging → Senders</em>.
          </Typography>
          <img src="../../static/docs/WhatsAppSenders.jpg" alt="Twilio phone number settings" className=".step-img-twilio half" />
        </ListItem>
      </List>
    </Box>
  );
}
